module.exports = __webpack_public_path__ + "img/2025-12-20g_2.f969f450.jpg";